import { NgModule } from '@angular/core';
import { LyCoreModule, LyTheme, AlyleServiceConfig } from 'alyle-ui/core';
var AlyleUIModule = /** @class */ (function () {
    function AlyleUIModule() {
    }
    AlyleUIModule.forRoot = function (config) {
        return {
            ngModule: AlyleUIModule,
            providers: [
                { provide: AlyleServiceConfig, useValue: config }
            ]
        };
    };
    AlyleUIModule.decorators = [
        { type: NgModule, args: [{
                    imports: [LyCoreModule.forRoot()],
                    exports: [LyCoreModule],
                    providers: [
                        LyTheme
                    ]
                },] },
    ];
    /** @nocollapse */
    AlyleUIModule.ctorParameters = function () { return []; };
    return AlyleUIModule;
}());
export { AlyleUIModule };
//# sourceMappingURL=alyle-ui.module.js.map